<script setup lang="ts">
/**
 * PDPA cookie-consent banner for Google Analytics. Shown only on builds with
 * a GA Measurement ID (prod) until the visitor accepts or declines; the
 * footer's "Cookie settings" link reopens it. Accept and Decline get equal
 * weight so declining is as easy as accepting.
 */
const { t } = useI18n()
const { gaMeasurementId } = useRuntimeConfig().public
const consent = useAnalyticsConsent()

const visible = computed(() => !!gaMeasurementId && consent.value === null)
</script>

<template>
  <div
    v-if="visible"
    role="region"
    :aria-label="t('consent.title')"
    data-testid="analytics-consent-banner"
    class="fixed inset-x-0 bottom-0 z-50 px-2 sm:px-4 pt-4 pb-[calc(0.5rem+env(safe-area-inset-bottom))] sm:pb-[calc(1rem+env(safe-area-inset-bottom))] pointer-events-none"
  >
    <div class="mx-auto max-w-3xl rounded-lg border border-default bg-default shadow-lg p-3 sm:p-4 flex flex-col gap-2 sm:gap-3 sm:flex-row sm:items-center pointer-events-auto">
      <p class="flex-1 text-xs sm:text-sm text-muted">
        {{ t('consent.message') }}
      </p>
      <div class="flex gap-2 shrink-0">
        <UButton
          :label="t('consent.decline')"
          color="neutral"
          variant="outline"
          class="flex-1 justify-center sm:flex-none"
          data-testid="analytics-consent-decline"
          @click="consent = 'denied'"
        />
        <UButton
          :label="t('consent.accept')"
          class="flex-1 justify-center sm:flex-none"
          data-testid="analytics-consent-accept"
          @click="consent = 'granted'"
        />
      </div>
    </div>
  </div>
</template>
